<script lang="ts">
    import { noPictureUrl } from '../../api/common';
    import { officialProfileRoute, type BillSponsor } from '../../api/bills';
    import * as t from '../../translations/Bills.ts';

    export let sponsor: BillSponsor;
    /** Primary sponsors show a portrait; cosponsors are a compact list. */
    export let showPhoto = false;
    /** False once the Profiles lookup says this official has no profile to show. */
    export let linkable = true;

    $: profileUrl = linkable && sponsor.officeOccupancyId !== 0 ? `#${officialProfileRoute(sponsor.officeOccupancyId)}` : null;

    function usePlaceholderPhoto(evt: Event) {
        const img = evt.currentTarget as HTMLImageElement;
        if (img.src !== noPictureUrl) img.src = noPictureUrl;
    }
</script>

<svelte:element
    this={profileUrl ? 'a' : 'div'}
    href={profileUrl}
    aria-label={profileUrl ? `${t.View_Profile()}: ${sponsor.description}` : undefined}
    class="group -mx-2 flex !no-underline items-center gap-3 rounded-lg px-2 py-1 {profileUrl
        ? 'transition-colors hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--vv-action-center-button-color,#2563eb)] focus-visible:ring-offset-2'
        : ''}"
    data-testid="bill-sponsor"
>
    {#if showPhoto}
        <img
            src={sponsor.photoUrl ?? noPictureUrl}
            alt=""
            class="h-10 w-10 shrink-0 rounded-full bg-gray-100 object-cover"
            loading="lazy"
            on:error={usePlaceholderPhoto}
        />
    {/if}
    <div class="min-w-0">
        <p class="text-sm font-medium {profileUrl ? 'text-[#1b75d0] group-hover:underline' : 'text-gray-900'}">{sponsor.name}</p>
        {#if sponsor.subtitle}
            <p class="text-xs text-gray-500">{sponsor.subtitle}</p>
        {/if}
    </div>
</svelte:element>
